import { render, staticRenderFns } from "./ImportThird.vue?vue&type=template&id=9ce380b8&scoped=true"
import script from "./ImportThird.vue?vue&type=script&lang=js"
export * from "./ImportThird.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ce380b8",
  null
  
)

export default component.exports